import React from 'react';

function AwardsRecognitionSection() {
  const styles = {
    section: {
      width: '100%', maxWidth: 1920, minHeight: 960, background: '#090909', opacity: 1,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '80px 80px', boxSizing: 'border-box', margin: '0 auto'
    },
    inner: {
      display: 'flex', width: '100%', maxWidth: 1440, margin: 0,
      gap: 40, alignItems: 'center',
      flexWrap: 'nowrap', flexDirection: 'row', justifyContent: 'space-between'
    },
    imageWrap: {
      flex: '0 0 44%', minWidth: 420, maxWidth: 640,
      display: 'flex', justifyContent: 'center', alignItems: 'center'
    },
    image: {
      width: '100%', height: 'auto', maxHeight: 640,
      objectFit: 'cover', objectPosition: 'center center', borderRadius: 8, opacity: 1, display: 'block'
    },
    content: {
      flex: '0 0 44%', minWidth: 420, maxWidth: 640,
      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start'
    },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.9)', margin: '0 0 12px 0'
    },
    dashLine: {
      width: 150, height: 0, borderTop: '2px solid #E73123', marginBottom: 24, flexShrink: 0
    },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '110%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123', display: 'inline'
    },
    titleWhite: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '110%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#FFFFFF', display: 'inline'
    },
    titleWrap: { marginBottom: 24 },
    paragraph: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: 'rgba(255,255,255,0.85)', margin: '0 0 32px 0', textAlign: 'left'
    },
    logoImg: { display: 'block', width: 'auto', height: 80, objectFit: 'contain', marginTop: 24 }
  };

  var para = "Our awards and recognitions reflect the trust we've earned through precision engineering, unwavering dedication, and consistent project excellence. Every milestone strengthens our reputation as a leader in foundation and infrastructure development.";

  return React.createElement('section', { style: styles.section, className: 'awards-recognition-section' },
    React.createElement('div', { style: styles.inner, className: 'awards-recognition-inner' },
      React.createElement('div', { style: styles.imageWrap, className: 'awards-image-wrap' },
        React.createElement('img', {
          src: '/businessman.jpg',
          alt: 'Awards and recognition',
          style: styles.image
        })
      ),
      React.createElement('div', { style: styles.content, className: 'awards-content' },
        React.createElement('h2', { style: styles.subheading }, 'AWARDS & RECOGNITION'),
        React.createElement('div', { style: styles.dashLine }),
        React.createElement('div', { style: styles.titleWrap },
          React.createElement('span', { style: styles.titleRed }, 'RECOGNITION '),
          React.createElement('span', { style: styles.titleWhite }, 'OF OUR COMMITMENT TO EXCELLENCE')
        ),
        React.createElement('p', { style: styles.paragraph }, para),
        React.createElement('img', { src: '/cwab.png', alt: 'CWAB Awards', style: styles.logoImg })
      )
    )
  );
}

export default AwardsRecognitionSection;
